module.exports = __webpack_public_path__ + "img/04.34dba951.png";